import CachedAccountOverview from '@/app/cached-account-overview/CachedAccountOverview'

export default [
  {
    path: '/backend/cached-account-overview',
    name: 'backend.cached-account-overview',
    component: CachedAccountOverview
  },
]
